import gql from 'graphql-tag';

export const createContact = gql`
	mutation CreateContact(
		$company: String!
		$email: String!
		$firstName: String!
		$lastName: String!
		$locationId: UUID
		$phoneNumber: String
		$countryCode: String
		$labels: [UUID]
	) {
		createContact(
			company: $company
			email: $email
			firstName: $firstName
			lastName: $lastName
			locationId: $locationId
			phoneNumber: $phoneNumber
			countryCode: $countryCode
			labels: $labels
		) {
			contact {
				firstName
				lastName
				company
				labels {
					name
					color
					pk
				}
				countryCode
				phoneNumber
				location {
					id
					name
				}
				pk
				email
			}
			success
		}
	}
`;

export const editContact = gql`
	mutation EditContact(
		$pk: UUID!
		$company: String
		$countryCode: String
		$email: String
		$firstName: String
		$labels: [UUID]
		$lastName: String
		$locationId: UUID
		$phoneNumber: String
		$removeLocation: Boolean
	) {
		editContact(
			pk: $pk
			company: $company
			countryCode: $countryCode
			email: $email
			firstName: $firstName
			labels: $labels
			lastName: $lastName
			locationId: $locationId
			phoneNumber: $phoneNumber
			removeLocation: $removeLocation
		) {
			success
		}
	}
`;

export const deleteContact = gql`
	mutation DeleteContact($pk: UUID!) {
		deleteContact(pk: $pk) {
			success
		}
	}
`;
